import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useWidth';
import useRoutes from '../useRoutes';
import RoutesContainer from '../RoutesContainer';
import useCheckAccess from '../../hooks/useCheckAccess';
import NotFound from '../../components/NotFound';

const PatientRoutes = () => {
    const isMobile = useCheckMobileScreen();
    const { notEditClinical } = useCheckAccess();
    const { patientAccess } = useCheckAccess();
    const { patientRoutes, allowedRoutes } = useRoutes();
    const routes = allowedRoutes(patientRoutes, patientAccess);
    const { pathname } = useLocation();
    const pathnames = pathname.split('/');
    const length = pathnames?.length;
    const lastParam = pathnames[length - 1];
    const existRoute = patientRoutes.some((item) => item.name === lastParam);
    const hasAccess = routes.some((item) => item.name === lastParam);
    const visibleNotFound = !hasAccess && existRoute;

    return (
        <RoutesContainer>
            <Switch>
                {routes
                    ?.filter((item) => item.isMobile !== !isMobile)
                    ?.map((route) => (
                        <Route key={route.id} {...route} />
                    ))}
                {visibleNotFound ? (
                    <NotFound />
                ) : (
                    <Redirect
                        to={`/:clinicId/patient/:id/${!notEditClinical ? 'forms/form' : 'profile'}`}
                    />
                )}
            </Switch>
        </RoutesContainer>
    );
};

export default PatientRoutes;
